
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M20 3.333c0 .4-.436.585-.818.469A10.923 10.923 0 0016 3.333c-1.114 0-2.179.164-3.182.469-.382.116-.818-.07-.818-.469 0-1.472 1.79-2.666 4-2.666s4 1.194 4 2.666z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26.333 24.667V16c0-6.124-4.497-11.333-10.333-11.333S5.667 9.877 5.667 16v8.667H4a1.333 1.333 0 100 2.666h24a1.333 1.333 0 100-2.666h-1.667zM16 7.333c-4.105 0-7.667 3.745-7.667 8.667v8.667h15.334V16c0-4.922-3.562-8.667-7.667-8.667z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M14.666 28.667c-.736 0-1.36.632-1.007 1.278a2.666 2.666 0 004.681 0c.354-.646-.27-1.278-1.007-1.278h-2.667z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      